import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  newsletterMessage = '';

  subscribe(event: Event): void {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const data = new FormData(form);
    const email = String(data.get('email') || '').trim();
    if (!email) {
      this.newsletterMessage = 'Please enter your email address.';
      return;
    }

    window.location.href = `mailto:info@anikinitek.com?subject=${encodeURIComponent('Newsletter subscription')}&body=${encodeURIComponent(`Please subscribe ${email} to the Anikini Technologies newsletter.`)}`;
    this.newsletterMessage = 'Your email app has been opened to send the newsletter request.';
    form.reset();
  }
}
